import React, { useEffect } from "react";
import SkipLink from "./SkipLink";
import Header from "./Header";
import Footer from "./Footer";

/**
 * Public root wrapper: every public page renders inside `.site` (spec c.10).
 * On a full load with a hash (e.g. /careers → /#team) the browser tries to scroll
 * before React has rendered the target, so scroll to it once after mount.
 */
const SiteLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    const id = decodeURIComponent(window.location.hash.slice(1));
    if (!id) return;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView();
  }, []);

  return (
    <div className="site">
      <SkipLink />
      <Header />
      <main id="main" tabIndex={-1}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default SiteLayout;
